/**
 * @module ui/financial-rates
 */
import { registerDialog } from "ui/dialog-manager";
import { qs } from "utils/utils";

/**
 * @method init
 * @description Initialize the modal dialog on the Financial Rates page
 */
export default function init() {
  const dialogId = "js-modal-dialog-financial-rates";

  registerDialog(dialogId, {
    populate: dialog => {
      const link = dialog.openButtonThatSpawnedDialog;
      const label = qs(".arc-c-financial-rates__link-text", link);
      label && dialog.setLabel(label.textContent);
      link && dialog.inject(`<iframe class="arc-c-financial-rates__iframe" src="${link.href}"></iframe>`);
    }
  });
}
